import classnames from "classnames";
import BenefitIcon from "static/svg/templates-store/benefit_icon.svg";
import { componentStyles } from "./benefit-component.scss";

const Benefit = ({ title, description, alignToCenter }) => {
  return (
    <div className={classnames("benefit-component", { "align-center": alignToCenter })}>
      <div className="benefit-icon-wrapper">
        <BenefitIcon className="benefit-icon" />
      </div>
      <div className="benefit-content">
        <div className="benefit-title">{title}</div>
        <div className="benefit-description">{description}</div>
      </div>
      <style jsx>{componentStyles}</style>
    </div>
  );
};

export default Benefit;
